var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h100-vh flex pad20 flex-column bg-f2" }, [
    _c("div", { staticClass: "f22 mar20-b lh-1 flex-shrink" }, [
      _vm._v("发票管理")
    ]),
    _c(
      "div",
      { staticClass: "flex-auto" },
      [
        _c("n-list-generato", {
          attrs: {
            border: "",
            searchData: _vm.searchData,
            theadData: _vm.theadData,
            tbodyData: _vm.tbodyData,
            total: _vm.total,
            pageSize: _vm.pageSize,
            "current-page": _vm.pageNum,
            "page-sizes": [10, 20, 30, 50, 100],
            "table-span-method": _vm.tableSpanMethod,
            buttonFunctionData: _vm.buttonFunctionData
          },
          on: {
            "update:currentPage": function($event) {
              _vm.pageNum = $event
            },
            "update:current-page": function($event) {
              _vm.pageNum = $event
            },
            searchSubmit: _vm.searchSubmit,
            "size-change": _vm.sizeChange,
            "current-change": _vm.currentChange,
            buttonFunctionRefresh: _vm.loadData,
            buttonFunctionExport: _vm.handleExport,
            orgIdListRemoteMethod: _vm.orgIdListRemoteMethod,
            orgIdListSelectChange: _vm.orgIdListSelectChange
          },
          scopedSlots: _vm._u([
            {
              key: "invoiceStatusCn",
              fn: function(slotProps) {
                return [
                  _c(
                    "span",
                    {
                      class: [
                        slotProps.row.invoiceStatus == "SUCCESS"
                          ? "green"
                          : "red"
                      ]
                    },
                    [_vm._v(_vm._s(slotProps.row.invoiceStatusCn))]
                  )
                ]
              }
            },
            {
              key: "contract",
              fn: function(slotProps) {
                return [
                  slotProps.row.contract && slotProps.row.contract.length
                    ? _vm._l(slotProps.row.contract, function(item) {
                        return _c(
                          "el-link",
                          {
                            key: item.contractId,
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.viewContract(item)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.templateName) +
                                "\n          "
                            )
                          ]
                        )
                      })
                    : _vm._e()
                ]
              }
            },
            {
              key: "fn",
              fn: function(slotProps) {
                return [
                  slotProps.row.invoiceFileList &&
                  slotProps.row.invoiceFileList.length
                    ? _vm._l(slotProps.row.invoiceFileList, function(
                        item,
                        index
                      ) {
                        return _c(
                          "el-link",
                          {
                            key: index,
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.viewFile(item.url)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getFileName(item.url)) +
                                "\n          "
                            )
                          ]
                        )
                      })
                    : _vm._e(),
                  !slotProps.row.invoiceStatus == "SUCCESS" ||
                  slotProps.row.invoiceFileList.length < 2
                    ? _c(
                        "el-upload",
                        {
                          attrs: {
                            "show-file-list": false,
                            limit:
                              2 - _vm.invoiceList.length == 0
                                ? -1
                                : 2 - _vm.invoiceList.length,
                            action:
                              _vm.env.VUE_APP_fileserver + "persistentUpload",
                            "file-list": _vm.invoiceList,
                            "on-success": _vm.uploadInvoiceSuccess,
                            "before-upload": function(file) {
                              return _vm.uploadInvoiceBefore(
                                file,
                                slotProps.row.orderId
                              )
                            },
                            "on-exceed": _vm.uploadInvoiceExceed
                          }
                        },
                        [
                          _c("el-link", { attrs: { type: "primary" } }, [
                            _vm._v("上传发票")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ]
              }
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }